import React from 'react';
import CourseTile from './course-tile';

const CourseList = ({ holes }) => {
    return (
        <div className="course__list">
            {
                holes.map((hole) => {
                    return (
                        <div className="course__li" key={hole.id}>
                            <CourseTile hole={hole} />
                        </div>
                    );
                })
            }
        </div>
    );
};

export default CourseList;
